module.exports = __webpack_public_path__ + "static/media/11.a91aca00.jpg";